<div class="incremental-stakes-container">
    @for (stake of stakeValues(); track stake) {
        <button class="incremental-stake-button" tabindex="-1" (click)="addToStake(stake.value)">
            <ms-dynamic-font-resizer [value]="stake.title" [defaultSize]="1" />
        </button>
    }
</div>
